import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DownIcon from '@mui/icons-material/ArrowDropDown';
import UpIcon from '@mui/icons-material/ArrowDropUp';
import LineIcon from '@mui/icons-material/UnfoldMoreOutlined';
import PassedIcon from '@mui/icons-material/Check';
import EditIcon from '@mui/icons-material/Edit';
import FailedIcon from '@mui/icons-material/Close';
import ButtonLoading from '../../../components/ButtonLoading';
import Input from '../../../components/Input';
import { createExecution } from '../../../api/projects';
import { toast } from "react-toastify";
import { SuiteTypes } from '../../../interfaces/SuiteTypes';
import { Box, IconButton } from '@mui/material';
import SubTitle from '../../../components/SubTitle';
import { CSSProperties } from 'react';
import { storage } from "../../../api/firebase";
import { getDownloadURL, ref, uploadBytes } from 'firebase/storage'
import Row from '../../../components/layout/Row';
import { colors } from '../../../assets/colors';
import CloseIcon from '@mui/icons-material/Close';
import DialogViewImage from './DialogViewImage';
import { mountHistory } from '../../../utils/history';
import { createHistory } from '../../../api/history';
import { ActionTypeEnum } from '../../../interfaces/HistoryTypes';

interface DialogCreateExecutionProps {
  open: boolean;
  close: () => void;
  suites: any;
  currentProject: any;
}

export default function DialogCreateExecution({ close, open, suites, currentProject }: DialogCreateExecutionProps) {

  const [suitesToExecution, setSuitesToExecution] = React.useState<SuiteTypes[]>();

  const [totalPassed, setTotalPassed] = React.useState(0);
  const [totalIgnored, setTotalIgnored] = React.useState(0);
  const [totalFailed, setTotalFailed] = React.useState(0);
  const [totalTests, setTotalTests] = React.useState(0);

  const [openImage, setOpenImage] = React.useState(false);
  const [imageToView, setImageToView] = React.useState<string>('');

  React.useEffect(() => {
    setSuitesToExecution(suites)
  }, [suites])

  const changeSuiteToExecution = (index: number, subindex: number, result: string) => {
    if (!suitesToExecution) return;
    var suiteChanged = suitesToExecution as unknown as SuiteTypes[];
    suiteChanged[index].test_cases[subindex].result = result

    if (result == 'FAILED') {
      if (suiteChanged) {
        if (suiteChanged) {
          suiteChanged[index].test_cases[subindex].editing = true;
        }
      }
    }

    if (result == 'PASSED') {
      if (suiteChanged) {
        suiteChanged[index].test_cases[subindex].editing = false;
      }
      suiteChanged[index].test_cases[subindex].reason = ''
    }

    setSuitesToExecution(suiteChanged ? [...suiteChanged] : [])
    checkQuantity(suiteChanged)
  };

  const changeReason = (index: number, subindex: number, reason: string) => {
    var suiteChanged = suitesToExecution
    if (!suiteChanged) return;
    suiteChanged[index].test_cases[subindex].reason = reason
    setSuitesToExecution(suiteChanged ? [...suiteChanged] : [])
  };

  const addImageOnFail = (index: number, subindex: number, image_failure: string) => {
    var suiteChanged = suitesToExecution
    if (!suiteChanged) return;
    suiteChanged[index].test_cases[subindex].image_failure = image_failure
    setSuitesToExecution(suiteChanged ? [...suiteChanged] : [])
  };

  const uploadImage = (index: number, subindex: number, inp: any) => {
    if (!inp) return

    const imageRef = ref(storage, `images/${inp.name + new Date().getTime()}`)

    uploadBytes(imageRef, inp)
      .then((result) => {
        getDownloadURL(result.ref)
          .then((imageUpload) => {
            console.log('Imagem enviada com sucesso: ', imageUpload)
            addImageOnFail(index, subindex, imageUpload)
            return imageUpload
          })
      })
  }

  const finishEditing = (index: number, subindex: number) => {
    var suiteChanged = suitesToExecution
    if (suiteChanged) {
      suiteChanged[index].test_cases[subindex].editing = false;
    }
    setSuitesToExecution(suiteChanged ? [...suiteChanged] : [])
  };

  const initEditing = (index: number, subindex: number) => {
    var suiteChanged = suitesToExecution
    if (suiteChanged) {
      suiteChanged[index].test_cases[subindex].editing = true;
    }
    setSuitesToExecution(suiteChanged ? [...suiteChanged] : [])
  };

  const checkQuantity = async (suiteChanged: SuiteTypes[]) => {
    var totalTestCases = 0

    var passed = 0
    var failed = 0
    var ignored = 0

    for (let i = 0; i < suiteChanged.length; i++) {
      const testCases = suiteChanged[i].test_cases.length
      totalTestCases += testCases

      for (let index = 0; index < testCases; index++) {
        if (suiteChanged[i].test_cases[index].result === 'PASSED') {
          passed = passed + 1
        } else if (suiteChanged[i].test_cases[index].result === 'FAILED') {
          failed = failed + 1
        } else if (suiteChanged[i].test_cases[index].result === 'IGNORED') {
          ignored = ignored + 1
        }
      }
    }

    setTotalTests(totalTestCases)

    setTotalPassed((100 * passed) / totalTestCases)
    setTotalFailed((100 * failed) / totalTestCases)
    setTotalIgnored((100 * ignored) / totalTestCases)
  };

  const renderPriority = (priority: string) => {
    switch (priority) {
      case 'LOW':
        return <UpIcon sx={{ color: 'green' }} />
      case 'MEDIUM':
        return <LineIcon sx={{ color: 'orange' }} />
      case 'HIGH':
        return <DownIcon sx={{ color: 'red' }} />;
      default:
        return <LineIcon sx={{ color: 'orange' }} />
    }
  };

  const backgroundColorResult = (result: any) => {
    switch (result) {
      case 'PASSED':
        return '#00800020'
      case 'IGNORED':
        return '#FFA6002F'
      case 'FAILED':
        return '#FF00001C'
      default:
        return '#F6F4F4A5'
    }
  };

  const saveExecution = () => {

    const data = {
      user_uuid: currentProject.user_uuid,
      project_id: currentProject.project_id,
      date: new Date().getTime(),
      totalTests,
      totalPassed,
      totalFailed,
      totalIgnored,
      result: suitesToExecution,
      id: String(new Date().getTime())
    }
    createExecution(data)
      .then(() => {
        toast.success("Execução criada com sucesso");
        createHistory(mountHistory(currentProject.project_id, ActionTypeEnum.CREATE, "Execução"))
        close();
      })
      .catch((e) => {
        toast.error("Ocorreu um problema, tente mais tarde!");
      })
      .finally(() => {
      });
  };

  const handleClose = () => {
    close()
  };

  const onViewImage = (img: string) => {
    setImageToView(img)
    setOpenImage(true)
  };

  const openId = React.useRef<number>(1);

  React.useEffect(() => {
    if (!open) { // Increment id each time modal closes
      openId.current = openId.current + 1;
    }
  }, [open]);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullScreen
      sx={style.container}
      keepMounted={false}
      key={openId.current} 
    >
      <DialogTitle >
        <Row space>
          Criar execução
          <IconButton onClick={handleClose}>
            <CloseIcon fontSize="inherit" />
          </IconButton>
        </Row>

      </DialogTitle>

      <Box sx={style.content}>

        <Box sx={style.chartContainer}>
          <SubTitle text='Andamento' />
          <Box sx={style.chartContent}>
            <Box sx={{ width: `${String(totalPassed)}%`, height: 24, backgroundColor: 'green', display: 'flex', alignItems: 'center', justifyContent: 'center', borderTopLeftRadius: 2, borderBottomLeftRadius: 2, }}>
              <SubTitle style={{ color: colors.white }} text={totalPassed > 0 ? totalPassed.toFixed(2) + '%' : ''} />
            </Box>
            <Box sx={{ width: `${String(totalFailed)}%`, height: 24, backgroundColor: 'red', display: 'flex', alignItems: 'center', justifyContent: 'center', borderTopRightRadius: 2, borderBottomRightRadius: 2 }}>
              <SubTitle style={{ color: colors.white }} text={totalFailed > 0 ? totalFailed.toFixed(2) + '%' : ''} />
            </Box>
            <Box sx={{ width: `${String(totalIgnored)}%`, height: 24, backgroundColor: '#FFA600FF', display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: 2, }}>
            </Box>
          </Box>
        </Box>

        {suitesToExecution && suitesToExecution.map((suite, index) =>

          <Box key={index + suite.id} style={style.testCasesContainer}>

            <h1 style={style.suiteTitle}>{suite.title}</h1>

            {suite.test_cases.map((test_case, subindex) =>

              <Box key={subindex + test_case.id} style={{ ...style.testCaseContent, backgroundColor: backgroundColorResult(test_case.result) }} >

                <Box key={index + subindex + test_case.id} style={style.infoContainer}>

                  <Box style={style.testCaseTitleContainer}>
                    <span key={subindex + test_case.id} style={style.testCaseTitle} >
                      {renderPriority(test_case.priority)}
                      {test_case.title}
                    </span>

                    <p key={subindex} style={style.testCaseSteps} >
                      <strong>Pré condições: </strong><br />{test_case.pre_conditions}
                    </p>

                    <p key={subindex} style={style.testCaseSteps} >
                      <strong>Passos: </strong><br />{test_case.steps}
                    </p>

                    <p key={subindex} style={style.testCaseSteps} >
                      <strong>Esperado: </strong><br />{test_case.expected_result}
                    </p>
                  </Box>

                  <div style={style.buttonsResultContainer}>

                    <div onClick={() => changeSuiteToExecution(index, subindex, 'PASSED')}
                      style={{ backgroundColor: test_case.result === 'PASSED' ? 'green' : 'white', border: '1px solid green', ...style.buttonResultContent }}
                    >
                      <PassedIcon style={{ color: test_case.result === 'PASSED' ? 'white' : 'green' }} />
                    </div>

                    {/* <div onClick={() => changeSuiteToExecution(index, subindex, 'IGNORED')}
                      style={{ cursor: 'pointer', marginLeft: 10, marginRight: 10, backgroundColor: test_case.result === 'IGNORED' ? '#FFE438FF' : 'white', width: 28, height: 28, display: 'flex', justifyContent: 'center', alignItems: 'center', border: '1px solid #FFE438FF', borderRadius: 100 }}
                    >
                      <span style={{ color: test_case.result === 'IGNORED' ? 'white' : '#FFE438FF', fontSize: 29 }}> - </span>
                    </div> */}

                    <div onClick={() => changeSuiteToExecution(index, subindex, 'FAILED')}
                      style={{ backgroundColor: test_case.result === 'FAILED' ? 'red' : 'white', border: '1px solid red', ...style.buttonResultContent }}
                    >
                      <FailedIcon style={{ color: test_case.result === 'FAILED' ? 'white' : 'red' }} />
                    </div>

                  </div>
                </Box>

                {test_case.result === 'FAILED' && test_case.editing &&
                  <div style={style.testCaseReasonContainer}>
                    <SubTitle text='Motivo da Falha' style={{ marginBottom: -1 }} />
                    <Input
                      placeholder={"Descreva a falha"}
                      value={test_case.reason}
                      multiline
                      rows={3}
                      onChange={(e) => changeReason(index, subindex, e.target.value)}
                      style={style.fieldReason}
                    />

                    <SubTitle text='Evidência' style={{ marginBottom: -1, marginTop: 4 }} />
                    <Input
                      type="file"
                      onChange={(e) => {
                        const file = (e.target as HTMLInputElement).files?.[0];
                        if (file) {
                          uploadImage(index, subindex, file)
                        }
                      }}
                    />

                    <img onClick={() => onViewImage(test_case.image_failure!)}
                      src={test_case.image_failure}
                      style={style.testCaseReasonImage}
                    />

                    <div onClick={() => finishEditing(index, subindex)}
                      style={style.buttonSaveFailureReason}
                    >
                      <PassedIcon style={style.iconSaveFailureReason} />
                    </div>
                  </div>
                }

                {test_case.result === 'FAILED' && !test_case.editing &&
                  <div style={style.testCaseReasonContainer}>
                    <SubTitle text='Motivo da Falha:' />
                    <p style={style.testCaseReason} >
                      {test_case.reason}
                    </p>
                    <SubTitle text='Evidência: ' style={{ marginTop: 4, marginBottom: 0 }} />
                    <img onClick={() => onViewImage(test_case.image_failure!)}
                      src={test_case.image_failure} style={style.testCaseReasonImage}
                    />

                    <div onClick={() => initEditing(index, subindex)}
                      style={{ marginTop: 6, cursor: 'pointer', backgroundColor: 'white', width: 22, height: 22, display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: 100 }}
                    >
                      <EditIcon style={{ color: colors.gray, width: 12 }} />
                    </div>

                  </div>
                }

              </Box>
            )}
          </Box>
        )}
      </Box >

      <Row style={{ paddingRight: 24, justifyContent: 'flex-end', gap: 12, marginTop: 12, marginBottom: 12 }}>
        <ButtonLoading
          label="Cancelar"
          onClick={handleClose}
          isDelete
        />

        <ButtonLoading
          label="Salvar execução"
          onClick={saveExecution}
        />
      </Row>

      {openImage &&
        <DialogViewImage
          imageToView={imageToView}
          open={openImage}
          close={() => setOpenImage(false)}
        />
      }
    </Dialog >
  );
}


const style: { [key: string]: CSSProperties } = {
  container: {
    alignContent: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    minWidth: 700,
    margin: 4,
  },

  content: {
    width: '100%',
    minWidth: 600,
    flexDirection: 'column',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingLeft: 5,
    paddingRight: 5,
  },

  chartContainer: {
    position: "sticky",
    top: 0,
    zIndex: 999,
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: 1,
    backgroundColor: colors.white,
    paddingTop: 2,
    paddingBottom: 2,
  },

  chartContent: {
    display: 'flex',
    flexDirection: 'row',
    border: '1px solid #ccc',
    borderRadius: 1,
    width: '100%',
  },

  testCasesContainer: {
    width: '100%',
    marginTop: 10,
    borderRadius: 6,
  },

  suiteTitle: {
    fontSize: 18,
    fontWeight: "600",
    backgroundColor: colors.background,
    padding: 12,
    borderRadius: 6
  },

  testCaseContent: {
    padding: 8,
    marginTop: 8,
    borderRadius: 6,
  },

  testCaseTitleContainer: {
    width: '90%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingLeft: 12,
    marginRight: 24
  },

  infoContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingLeft: 8,
    paddingRight: 8,
  },

  testCaseTitle: {
    marginTop: 16,
    marginBottom: 16,
    justifyContent: 'start',
    alignItems: 'center',
    display: 'flex',
    marginLeft: -10,
    fontWeight: 500,
    color: colors.black
  },

  testCaseSteps: {
    fontSize: 12,
    color: colors.gray,
    whiteSpace: 'pre-wrap',
    height: 100,
  },

  buttonsResultContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    backgroundColor: colors.background,
    alignItems: 'center',
    height: 80,
    width: 90,
    borderRadius: 12
  },

  buttonResultContent: {
    width: 28,
    height: 28,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 100,
    cursor: 'pointer',
    marginRight: 8,
    marginLeft: 8
  },

  fieldReason: {
    fontSize: 12,
    width: '100%'
  },

  buttonSaveFailureReason: {
    marginTop: 12,
    cursor: 'pointer',
    backgroundColor: colors.white,
    width: 22,
    height: 22,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 100
  },

  iconSaveFailureReason: {
    color: colors.gray,
    width: 12,
  },

  testCaseReasonContainer: {
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    marginTop: 16,
    padding: 16,
    margin: 8,
    borderRadius: 8,
    backgroundColor: '#FEDDDDFF',

  },

  testCaseReason: {
    fontSize: 12,
    width: '100%',
    whiteSpace: 'pre-wrap',
  },

  testCaseReasonImage: {
    marginTop: 12,
    width: '10%',
    cursor: 'pointer',
  }
}